export function friendUnreadTotal(unread = {}, conversationUnread = null) {
  const officialUnread = Number(unread.all || 0) > 0 ? 1 : 0
  const conversationUnreadValue = conversationUnread === null || conversationUnread === undefined
    ? Number(unread.chat || 0)
    : Number(conversationUnread || 0)
  const requestUnread = Number(unread.chat_requests || 0)
  return officialUnread + conversationUnreadValue + requestUnread
}
